import React from "react";
import Responsive from "react-responsive";

export const Desktop = props => <Responsive {...props} minWidth={1024} />;
export const Mobile = props => <Responsive {...props} maxWidth={1023} />;
export const NotPhone = props => <Responsive {...props} minWidth={813} />;
export const Tablet = props => (
  <Responsive {...props} minWidth={768} maxWidth={1023} />
);
export const Phone = props => <Responsive {...props} maxWidth={812} />;

export const helloAvaTheme = {
  botBubbleColor: "rgba(255, 173, 148, 0.1)",
  botFontColor: "black",
  userBubbleColor: "rgba(151, 151, 151, 0.1)",
  userFontColor: "black"
};

export const quizStyle = {
  height: "100%",
  // display: 'flex',
  // overflow: 'hidden',
  padding: "8vh 0 2%"
};

export const quizStyleHair = {
  height: "100%",
  overflow: "hidden",
  padding: "12vh 0 0"
};

export const quizStyleMobile = {
  height: "100%",
  overflow: "hidden",
  padding: "4vh 0 2%"
};

export const quizStyleMobileHair = {
  height: "100%",
  overflow: "hidden",
  padding: "7.5vh 0 2%"
};

export const chatContainerStyle = {
  // paddingTop: "30px",
  // height: "100%",
  // // overflow: 'hidden',
  // flexBasis: "100%",
  // overflow: "hidden"
  height: "100%",
  maxHeight: "100%",
  width: "100%"
};

export const chatContainerStyleMobile = {
  paddingTop: "23px",
  height: "100%"
};

export const chatContainerStyleHair = {
  paddingTop: "2vh",
  paddingBottom: "3vh",
  height: "100%"
};

export const chatbotStyle = {
  // width: "104%",
  // maxWidth: "996px",
  // height: "100%",
  // //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
  // background: "#fff",
  // overflowX: "hidden",
  // overflowY: "scroll"
};

export const chatContentStyle = {
  height: "100%",
  overflowX: "hidden",
  padding: "0",
  margin: "0",
  paddingTop: "0.5em",
  paddingLeft: '11%',
};

export const chatContentStyleMobile = {
  height: "100%",
  overflowX: "hidden",
  padding: "0",
  margin: "0",
  paddingTop: "0.5em",
  paddingLeft: '0',
};


export const chatbotContentStyleMobile = {
  height: "68vh",
  margin: "0",
  padding: "0 25px 0 0",
  width: "100%",
  overflowScrolling: "touch"
};

export const chatbotContentStyleMobileHair = {
  height: "95%",
  margin: "0",
  padding: "0 25px 0 0",
  width: "100%",
  overflowScrolling: "touch"
};

export const chatbotAvatarStyle = {
  width: "44px",
  height: "44px",
  borderRadius: '50%',
  padding: 0,
};

export const chatbotAvatarStyleMobile = {
  width: "40px",
  height: "40px",
  borderRadius: '50%',
  padding: 0,
};

export const chatbotBubbleStyle = {
  fontFamily: "Montserrat",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: '19px',
  letterSpacing: "0px",
  textAlign: "left",
  padding: "17px 25px 17px 25px",
  margin: "0 0 10px 0",
  borderRadius: "12px",
  backgroundColor: "#E1E9EB",
  color:'#272D67',
};

export const chatbotBubbleStyleMobile = {
  fontFamily: "Montserrat",
  fontSize: "16px",
  color: "#272D67",
  fontWeight: 400,
  lineHeight: '19px',
  letterSpacing: "0px",
  textAlign: "left",
  padding: "10px 18px",
  margin: "0 0 10px 0",
  overflowY: "scroll",
  borderRadius: "12px",
  flex:1,
  backgroundColor: "#E1E9EB",
  maxWidth: '100%'
};

// This is for custom component - name, skin concerns, products and allergies
export const answerBubbleStyle = {
  fontFamily: "Montserrat",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: '19px',
  letterSpacing: "0px",
  textAlign: "left",
  padding: "17px 25px 17px 25px",
  // margin: "0 0 10px 0",
  borderRadius: "12px",
  // backgroundColor: "rgba(151, 151, 151, 0.1)",
  backgroundColor: 'rgba(151, 151, 151, 0.1)',
  color: "#272D67",
  maxWidth: "50%"
};

export const answerBubbleStyleMobile = {
  fontFamily: "Montserrat",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: '19px',
  letterSpacing: "0px",
  textAlign: "left",
  padding: "10px 20px",
  // margin: "0 0 10px 0",
  borderRadius: "12px",
  // backgroundColor: "#E1E9EB",
  backgroundColor: 'rgba(151, 151, 151, 0.1)',
  color: "#272D67",
  maxWidth: "71%"
};

export const chatbotFooterStyle = { display: "none" };



// WEBPACK FOOTER //
// ./src/utils/styles.js